<template>
  <div class="row">
    <div class="small-8 columns with-right-space">
      <p
        v-if="!uiFlags.isFetching && !records.length"
        class="no-items-error-message"
      >
        {{ $t(`${i18nPrefix}.LIST.404`) }}
      </p>
      <woot-loading-state
        v-if="uiFlags.isFetching"
        :message="$t(`${i18nPrefix}.LOADING`)"
      />
      <table v-if="!uiFlags.isFetching && records.length" class="woot-table">
        <thead>
          <th
            v-for="thHeader in $t(`${i18nPrefix}.LIST.TABLE_HEADER`)"
            :key="thHeader"
          >
            {{ thHeader }}
          </th>
        </thead>
        <tbody>
          <tr v-for="label in records" :key="label.title">
            <td class="label-title">
              <span class="text-truncate">{{ label.title }}</span>
            </td>
            <td>{{ label.description }}</td>
            <td>
              <div class="label-color--container">
                <span
                  class="label-color--display"
                  :style="{ backgroundColor: label.color }"
                />
                {{ label.color }}
              </div>
            </td>
            <td class="button-wrapper">
              <woot-button
                v-tooltip.top="$t(`${i18nPrefix}.FORM.EDIT`)"
                variant="smooth"
                size="tiny"
                color-scheme="secondary"
                class-names="grey-btn"
                :is-loading="loading[label.id]"
                icon="edit"
                @click="openEditPopup(label)"
              />
              <woot-button
                v-tooltip.top="$t(`${i18nPrefix}.FORM.DELETE`)"
                variant="smooth"
                color-scheme="alert"
                size="tiny"
                icon="dismiss-circle"
                class-names="grey-btn"
                :is-loading="loading[label.id]"
                @click="openDeletePopup(label)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="small-4 columns">
      <span v-dompurify-html="$t(`${i18nPrefix}.SIDEBAR_TXT`)" />
    </div>

    <woot-modal :show.sync="showEditPopup" :on-close="hideEditPopup">
      <edit-label
        :type="type"
        :selected-response="selectedResponse"
        @close="hideEditPopup"
      />
    </woot-modal>

    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t(`${i18nPrefix}.DELETE.CONFIRM.TITLE`)"
      :message="$t(`${i18nPrefix}.DELETE.CONFIRM.MESSAGE`)"
      :message-value="deleteMessage"
      :confirm-text="deleteConfirmText"
      :reject-text="deleteRejectText"
    />
  </div>
</template>
<script>
import EditLabel from './EditLabel';
import alertMixin from 'shared/mixins/alertMixin';
import { DEFAULT_LABEL_TYPE, findLabelType } from './labelTypes';

export default {
  components: {
    EditLabel,
  },
  mixins: [alertMixin],
  props: {
    type: {
      type: String,
      default: DEFAULT_LABEL_TYPE,
    },
  },
  data() {
    return {
      loading: {},
      showEditPopup: false,
      showDeleteConfirmationPopup: false,
      selectedResponse: {},
    };
  },
  computed: {
    labelType() {
      return findLabelType(this.type);
    },
    i18nPrefix() {
      return this.labelType.i18nPrefix;
    },
    records() {
      const { storeModule, recordsGetter } = this.labelType;
      return this.$store.getters[`${storeModule}/${recordsGetter}`];
    },
    uiFlags() {
      return this.$store.getters[`${this.labelType.storeModule}/getUIFlags`];
    },
    deleteConfirmText() {
      return `${this.$t(`${this.i18nPrefix}.DELETE.CONFIRM.YES`)} ${
        this.selectedResponse.title
      }`;
    },
    deleteRejectText() {
      return `${this.$t(`${this.i18nPrefix}.DELETE.CONFIRM.NO`)} ${
        this.selectedResponse.title
      }`;
    },
    deleteMessage() {
      return ` ${this.selectedResponse.title}?`;
    },
  },
  mounted() {
    this.$store.dispatch(`${this.labelType.storeModule}/get`);
  },
  methods: {
    openEditPopup(response) {
      this.showEditPopup = true;
      this.selectedResponse = response;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },

    openDeletePopup(response) {
      this.showDeleteConfirmationPopup = true;
      this.selectedResponse = response;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },

    confirmDeletion() {
      this.loading[this.selectedResponse.id] = true;
      this.closeDeletePopup();
      this.deleteLabel(this.selectedResponse.id);
    },
    deleteLabel(id) {
      this.$store
        .dispatch(`${this.labelType.storeModule}/delete`, id)
        .then(() => {
          this.showAlert(
            this.$t(`${this.i18nPrefix}.DELETE.API.SUCCESS_MESSAGE`)
          );
        })
        .catch(() => {
          this.showAlert(
            this.$t(`${this.i18nPrefix}.DELETE.API.ERROR_MESSAGE`)
          );
        })
        .finally(() => {
          this.loading[this.selectedResponse.id] = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/variables';

.label-color--container {
  display: flex;
  align-items: center;
}

.label-color--display {
  border-radius: $space-smaller;
  height: $space-normal;
  margin-right: $space-smaller;
  width: $space-normal;
  border: 1px solid var(--color-border-light);
}
.label-title {
  span {
    width: var(--space-giga);
    display: inline-block;
  }
}
.woot-table {
  margin-bottom: var(--space-larger);
}
</style>
